import React, { FunctionComponent } from 'react';
import Translate from 'ui/atoms/translate';
import { Modal, ModalHeader, ModalContent, ModalFooter, ModalFooterButtons } from 'ui/molecules/modal';
import Hint from 'src/ui/atoms/hint';

interface DeletePermissionSuccessModalProps {
  onClose: () => void;
}

const DeletePermissionSuccessModal: FunctionComponent<DeletePermissionSuccessModalProps> = ({ onClose }) => {
  return (
    <Modal onClose={onClose}>
      <ModalHeader>
        <Translate name="deletePermissionSuccessModal.title" />
      </ModalHeader>
      <ModalContent>
        <Hint variant="success">
          <Translate name="deletePermissionSuccessModal.hint" />
        </Hint>
      </ModalContent>
      <ModalFooter>
        <ModalFooterButtons
          actionButtons={[
            {
              name: 'close',
              content: <Translate name="common.close" />,
              size: 'large',
              onClick: () => onClose(),
            },
          ]}
        />
      </ModalFooter>
    </Modal>
  );
};

export default DeletePermissionSuccessModal;
